import html2canvas from "html2canvas";

const waitForImages = (container) => {
  const images = Array.from(container.querySelectorAll("img"));

  return Promise.all(
    images.map((img) => {
      if (img.complete && img.naturalWidth > 0) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    }),
  );
};

const createMapUrl = ({ latitude, longitude, googleMapKey }) => {
  if (!latitude || !longitude) {
    return "";
  }

  return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=18&size=200x200&maptype=hybrid&markers=color:red%7C${latitude},${longitude}&key=${googleMapKey}`;
};

export const CreateGeotaggedImage = async ({
  file,
  latitude,
  longitude,
  address,
  city,
  state,
  zipCode,
  googleMapKey,
}) => {
  const objectUrl = URL.createObjectURL(file);

  const container = document.createElement("div");

  container.style.position = "fixed";
  container.style.left = "-10000px";
  container.style.top = "0";
  container.style.width = "800px";
  container.style.background = "#ffffff";
  container.style.zIndex = "-1";

  const locationName = [city, state].filter(Boolean).join(", ");

  const fullAddress = [address, zipCode].filter(Boolean).join(", ");

  const mapUrl = createMapUrl({
    latitude,
    longitude,
    googleMapKey,
  });

  const dateTime = new Date().toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });

  container.innerHTML = `
    <div
      style="
        position: relative;
        width: 100%;
        background: #ffffff;
      "
    >
      <img
        src="${objectUrl}"
        alt="Installation"
        style="
          display: block;
          width: 100%;
          height: auto;
        "
      />

      <div
        style="
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.85);
          color: #ffffff;
          padding: 15px;
          display: flex;
          gap: 15px;
          align-items: center;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        "
      >

        ${
          mapUrl
            ? `
              <img
                src="${mapUrl}"
                alt="Location Map"
                crossorigin="anonymous"
                style="
                  width: 200px;
                  height: 200px;
                  object-fit: cover;
                  flex-shrink: 0;
                "
              />
            `
            : ""
        }

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 8px;
            font-size: 18px;
          "
        >

          ${
            locationName
              ? `
                <div
                  style="
                    font-weight: 700;
                    font-size: 22px;
                  "
                >
                  ${locationName}
                </div>
              `
              : ""
          }

          ${
            fullAddress
              ? `
                <div style="text-transform: uppercase;">
                  ${fullAddress}
                </div>
              `
              : ""
          }

          ${
            latitude && longitude
              ? `
                <div>
                  Lat ${latitude}, Long ${longitude}
                </div>
              `
              : ""
          }

          <div>
            ${dateTime}
          </div>

        </div>
      </div>
    </div>
  `;

  document.body.appendChild(container);

  try {
    await waitForImages(container);

    const canvas = await html2canvas(container, {
      scale: 1,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", 0.8);
    });

    if (!blob) {
      throw new Error("Failed to generate geotagged image");
    }

    return new File([blob], `installation-${Date.now()}.jpg`, {
      type: "image/jpeg",
    });
  } finally {
    document.body.removeChild(container);
    URL.revokeObjectURL(objectUrl);
  }
};
